// Comprueba que una URL use un protocolo permitido. Bloquea `javascript:`,
// `data:` y similares, que React no filtra en href.
export const isSafeUrl = (value, protocols = ["http:", "https:"]) => {
    try {
        return protocols.includes(new URL(String(value ?? "").trim()).protocol);
    } catch {
        return false;
    }
};

// Para usar en href/src con datos guardados: devuelve la URL solo si es http(s).
export const safeUrl = (value) => (isSafeUrl(value) ? String(value).trim() : undefined);
